module.exports = __webpack_public_path__ + "static/media/65.ad523ace.jpg";